import React from 'react'
import { Text } from 'react-native'

export const QuestionTitle: React.FC<{ title: string; subtitle?: string }> = ({
  title,
  subtitle,
}) => {
  return (
    <>
      <Text
        style={{
          fontWeight: '700',
          fontSize: 20,
          lineHeight: 28,
          color: '#394D5A',
          marginTop: 20,
          marginBottom: subtitle ? 4 : 20,
        }}
      >
        {title}
      </Text>
      {subtitle && (
        <Text
          style={{
            fontWeight: '400',
            fontSize: 14,
            lineHeight: 20,
            color: '#394D5A',
            marginBottom: 20,
            letterSpacing: -0.5,
          }}
        >
          {subtitle}
        </Text>
      )}
    </>
  )
}

export const SectionTitle: React.FC = ({ children }) => {
  return (
    <Text
      style={{
        fontWeight: '700',
        fontSize: 28,
        lineHeight: 48,
        color: '#394D5A',
        marginTop: 40,
        marginBottom: 20,
      }}
    >
      {children}
    </Text>
  )
}

export const SectionSubtitle: React.FC = ({ children }) => {
  return (
    <Text
      style={{
        fontWeight: '500',
        fontSize: 16,
        lineHeight: 20,
        color: '#394D5A',
        marginTop: -15,
        marginBottom: 30,
        letterSpacing: -0.5,
      }}
    >
      {children}
    </Text>
  )
}
